// @ts-ignore
jQuery(function ($) {
	//Le plugin dearflip fonctionne avec jQuery donc ne cherchez pas à faire sans ;)
	$(document).ready(function () {
		$('[data-doc]').on(
			'click',
			'[data-document-pdf-reader]',
			function () {
				const urlPDF = $(this).attr('data-document-pdf-reader');

				const pdfReaderExisting = $('#pdfReader');
				if (!pdfReaderExisting.length) {
					$('body').append('<div id="pdfReader"></div>');
				}
				$('body').css('overflow-y', 'hidden');

				const options = {
					soundEnable: true,
					height: '100%',
					duration: 800,
					backgroundColor: 'rgba(0, 0, 0, 0.9)',
					text: {
						toggleSound: 'Activer/désactiver le son',
						toggleThumbnails: 'Afficher les miniatures',
						toggleOutline: 'Afficher les ancres',
						previousPage: 'Page précédente',
						nextPage: 'Page suivante',
						toggleFullscreen: 'Plein écran',
						zoomIn: 'Zoomer',
						zoomOut: 'Dézoomer',
						toggleHelp: "Activer l'aide",
						singlePageMode: 'Une page',
						doublePageMode: 'Double page',
						downloadPDFFile: 'Télécharger le PDF',
						gotoFirstPage: 'Première page',
						gotoLastPage: 'Dernière page',
						share: 'Partager',
					},
					onCreateUI: function () {
						//Ajout d'un bouton pour fermer la modale
						$('#pdfReader').append(
							'<div class="df-close-btn df-ui-btn ti-close"></div>'
						);

						$('.df-close-btn').on('click', function () {
							$('#pdfReader').remove();
							$('body').css('overflow-y', 'auto');
						});
					},
				};

				// @ts-ignore
				const flipBook = $('#pdfReader').flipBook(urlPDF, options);
			}
		);
	});
});
